import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import Dialog from 'components/dialog';
import { t } from 'state/intl/translations';

import { ISaveFavoriteOrderUnsavedProps } from './types';

/**
 *
 * Save Favorite Order Unsaved Changes
 *
 *
 */

const ButtonContainer = Box.withConfig({
  margin: '$2',
  width: 'full',
});

const TextStyled = withTypography({ m: '$2' });

export const SaveFavoriteOrderUnsaved: FC<React.PropsWithChildren<
  ISaveFavoriteOrderUnsavedProps
>> = ({ onSave, onDiscard, onDismiss }) => {
  return (
    <Dialog
      showDialog
      testID="save-favorite-order-unsaved"
      onDismiss={() => null}
      modalAppearanceEventMessage="Save Favorite Order"
      heading={t('saveFavoriteOrderUnsaved')}
      bodyComponent={<TextStyled>{t('saveFavoriteOrderUnsavedBody')}</TextStyled>}
      actions={
        <>
          <ButtonContainer>
            <ActionButton fullWidth onPress={onSave} testID="save-favorite-order-save-changes">
              {t('saveChanges')}
            </ActionButton>
          </ButtonContainer>
          <ButtonContainer>
            <ActionButton
              fullWidth
              onPress={onDiscard}
              testID="save-favorite-order-discard-changes"
            >
              {t('discardChanges')}
            </ActionButton>
          </ButtonContainer>
          <ButtonContainer>
            <ActionButton
              fullWidth
              onPress={onDismiss}
              testID="save-favorite-order-cancel"
              variant={ActionButtonVariants.OUTLINE}
            >
              {t('cancel')}
            </ActionButton>
          </ButtonContainer>
        </>
      }
    />
  );
};
